import {
  TransferReminder,
  TransferReminderInput
} from '../../lib/types/models/transfer/transfer-reminder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTransferReminder(
  input: TransferReminderInput & { id: number; transferId: number }
) {
  const { id, transferId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.transfer.updateReminder.url, { id, transferId }))
    .patch<TransferReminder, TransferReminderInput>(data)
}
